<template>
  <div>
    <div class="d-flex mb-2">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          SPU：{{ formData.evgSpuNo }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyDate ? formData.modifyDate : '--' }}
        </span>
      </div>
    </div>
    <el-form ref="form" :model="formData" :rules="rules" size="small">
      <div class="d-flex">
        <div
          @click="previewImage"
          class="mr-2"
          style="display: flex;flex-direction: column;align-items: center;"
        >
          <el-image
            style="width: 140px; height: 140px;"
            fit="scale-down"
            :src="
              formData.defaultImageUrl
                ? $osscdn(formData.defaultImageUrl)
                : '/image/static/img/nopic.jpg'
            "
          >
            <div slot="error" class="image-slot">
              <img
                src="/image/static/img/nopic-square.jpg"
                style="width: 140px; height: 140px;"
              />
            </div>
          </el-image>
        </div>
        <div style="flex:1;">
          <div class="d-flex bt-1 bb-1 bl-1">
            <LabelValue>
              <template v-slot:label>{{
                $l('form_label_sd_spu_number') || 'SPU number'
              }}</template>
              <template v-slot:value>{{ formData.evgSpuNo }}</template>
            </LabelValue>
            <LabelValue>
              <template v-slot:label>{{
                $l('form_label_sd_modifyDate') || 'Last update'
              }}</template>
              <template v-slot:value>
                {{ formData.modifyByName ? formData.modifyByName : '--' }} at
                {{ formData.modifyDate ? formData.modifyDate : '--' }}</template
              >
            </LabelValue>
          </div>
          <div class="d-flex bb-1 bl-1">
            <LabelValue>
              <template v-slot:label>{{
                $l('form_label_sd_goodsName') || 'Chinese name'
              }}</template>
              <template v-slot:value>{{ formData.goodsName }}</template>
            </LabelValue>
            <LabelValue>
              <template v-slot:label>{{
                $l('form_label_sd_goodsNameEn') || 'English name'
              }}</template>
              <template v-slot:value>{{ formData.goodsNameEn }}</template>
            </LabelValue>
          </div>
          <div class="d-flex bb-1 bl-1">
            <LabelValue>
              <template v-slot:label>{{
                $l('form_label_sd_custName') || 'Customer'
              }}</template>
              <template v-slot:value>{{ formData.custName }}</template>
            </LabelValue>
            <LabelValue>
              <template v-slot:label>{{
                $l('form_label_sd_brandName') || 'Brand'
              }}</template>
              <template v-slot:value>{{ formData.brandName }}</template>
            </LabelValue>
          </div>
          <div class="d-flex bb-1 bl-1">
            <LabelValue>
              <template v-slot:label>{{
                $l('form_label_sd_categoryName') || 'Category'
              }}</template>
              <template v-slot:value>{{ formData.categoryFullName }}</template>
            </LabelValue>
            <LabelValue>
              <template v-slot:label>{{
                $l('form_label_sd_collectionName') || 'Collection'
              }}</template>
              <template v-slot:value>{{ formData.collectionName }}</template>
            </LabelValue>
          </div>
        </div>
      </div>
      <el-row v-if="type === 'reject'">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_detail_rejectReason') || '驳回原因'"
            prop="rejectReason"
          >
            <el-input
              v-model="formData.rejectReason"
              :placeholder="
                $l('tips_input_placeholder_rejectReason') || '请输入驳回原因'
              "
              clearable
              type="textarea"
              :maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <SpuImage
      v-if="spuImageVisible"
      :visible.sync="spuImageVisible"
      :evgSpuCode="this.formData.evgSpuCode"
      :title="$l('form_label_picture_maintenance') || '图片维护'"
    />

    <div v-show="false" class="image-viewer" v-viewer="{ movable: true }">
      <img
        v-for="item in displayImageUrls"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="item"
      />
    </div>

    <el-dialog
      width="30%"
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      append-to-body
      v-el-dialog-drag
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="reject()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import SpuImage from './spu-image'
import LabelValue from './label-value.vue'
export default {
  mixins: [EditLoading],
  components: { SpuImage, LabelValue },
  props: {
    type: { type: String, default: '' },
    evgSpuCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      backDialogVisible: false,
      rules: {
        rejectReason: [
          {
            required: true,
            message:
              this.$l('rules_input_rejectReason') || '请输入驳回原因',
            trigger: 'blur',
          },
        ],
      },
      spuImageVisible: false,
    }
  },
  computed: {
    displayImageUrls() {
      const { listImageUrl } = this.formData
      return listImageUrl?.map((item) => item.displayImageUrl) || []
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.evgSpuCode) return
      const res = await this.$api
        .ecomEvgSpuDetailApi({ evgSpuCode: this.evgSpuCode })
        .catch(() => null)
      if (!res) return
      this.formData = res.body
    },
    previewImage() {
      if (!this.displayImageUrls || !this.displayImageUrls.length) return
      const viewer = this.$el.querySelector('.image-viewer').$viewer
      const index = this.displayImageUrls.findIndex(
        (item) => item === this.formData.defaultImageUrl
      )
      viewer.view(index)
      viewer.show()
    },
    async approved() {
      const confirm = await this.$confirm(
        this.$l('tips_detail_approved_confirm_content') ||
          '是否要通过该SPU转正申请？',
        this.$l('tips_detail_approved_confirm_title') || '确认信息',
        {
          confirmButtonText: this.$l('btn_detail_approved_confirm') || '确定',
          cancelButtonText: this.$l('btn_detail_approved_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const listEvgSpuCode = [this.evgSpuCode]
      const res = await this.$api
        .ecomEvgSpuApprovedApi({ listEvgSpuCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(
          this.$l('message_detail_approved_error') || '通过失败！'
        )
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('message_detail_approved_success') || '通过成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.close()
    },
    async reject() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      const confirm = await this.$confirm(
        this.$l('tips_detail_reject_confirm_content') ||
          '是否要驳回该SPU转正申请？',
        this.$l('tips_detail_reject_confirm_title') || '确认信息',
        {
          confirmButtonText: this.$l('btn_detail_reject_confirm') || '确定',
          cancelButtonText: this.$l('btn_detail_reject_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomEvgSpuRejectApi(this.formData)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(
          this.$l('message_detail_reject_error') || '驳回失败！'
        )
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('message_detail_reject_success') || '驳回成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.close()
      this.loadingClose()
    },
    cancel() {
      if (['approved', 'detail'].includes(this.type)) return this.close()
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}

.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
}

.el-row {
  display: flex;
  align-items: stretch;
}
.image-col {
  padding: 0;
}
.image-wrapper {
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}
.image-wrapper img {
  max-width: 100%;
  max-height: 100%;
}
.text-col {
  padding: 0;
}
.text-wrapper {
  padding: 20px;
}
.bt-1 {
  border-top: 1px solid #efefef;
}
.bb-1 {
  border-bottom: 1px solid #efefef;
}
.bl-1 {
  border-left: 1px solid #efefef;
}
</style>
